var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"not-found"},[_vm._v("\n    非常抱歉，您访问的页面已经不存在！\n  ")])])}]

export { render, staticRenderFns }